<div class="login-container">
@if (!isTimesheetEnabled) {
  <ng-container
    style="position: relative"
    >
    <div class="message">
      <h1>Timesheet is disabled for your company.</h1>
    </div>
  </ng-container>
} @else {
  @if (accessType && accessType == 'In App') {
    <ng-container
      style="position: relative"
      >
      <div class="message">
        <h1>
          Kiosk is disabled for your company. <br />
          Regular in app clock in/out is available.
        </h1>
      </div>
    </ng-container>
  } @else {
    <form
      [formGroup]="authForm"
      (ngSubmit)="onHandleSubmit()"
      class="login-form"
      >
      <div class="row centered">
        <div class="left-section">
          <mat-card appearance="outlined">
            @if ((companyDetails$ | async); as detail) {
              <div class="company-logo">
                <img [src]="detail.logo" />
              </div>
            }
            @if (activeField == 'kiosk_id') {
              <div>
                <h1 class="title">
                  Welcome to the <br />
                  HappyHR Kiosk!
                </h1>
                <mat-form-field appearance="fill" class="full-width outlined">
                  <input
                    matInput
                    formControlName="kiosk_id"
                    placeholder="Enter kiosk employee ID"
                    [value]="authForm.value?.kiosk_id"
                    readonly
                    />
                  @if (
                    authForm.get('kiosk_id')?.invalid &&
                    authForm.get('kiosk_id')?.touched
                    ) {
                    <mat-error
                      >
                      Kiosk ID is required
                    </mat-error>
                  }
                </mat-form-field>
                <div class="forgot-id">
                  <span class="clickable" (click)="onHandleForgot('id')"
                    >Forgot employee ID</span
                    >
                  </div>
                </div>
              }
              @if (activeField === 'kiosk_pin') {
                <mat-form-field appearance="fill" class="full-width outlined">
                  <input
                    type="password"
                    matInput
                    formControlName="kiosk_pin"
                    placeholder="Enter kiosk PIN"
                    readonly
                    />
                  @if (
                    authForm.get('kiosk_pin')?.invalid &&
                    authForm.get('kiosk_pin')?.touched
                    ) {
                    <mat-error
                      >
                      Kiosk PIN is required
                    </mat-error>
                  }
                </mat-form-field>
                <div class="actions-section">
                  <div class="clickable dflex-center" (click)="onHandleBack()">
                    <mat-icon
                      aria-hidden="false"
                      aria-label="Example home icon"
                      fontIcon="arrow_back"
                    ></mat-icon>
                    Back to kiosk ID
                  </div>
                  <div
                    class="forgot-id clickable dflex-center"
                    (click)="onHandleForgot('pin')"
                    >
                    Forgot kiosk PIN
                  </div>
                </div>
              }
            </mat-card>
          </div>
          <div class="right-section">
            <app-numeric-keypad
              (eventOnKeyPress)="onHandleKeyPress($event)"
              (eventOnclear)="onHandleClear()"
              (eventOnOk)="onHandleOk()"
              [isLoading]="isLoading"
            ></app-numeric-keypad>
          </div>
        </div>
      </form>
    }
  }
</div>